module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/28/assets/images/e2aaa217a95ef9a473a72c7c04846d48.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_information.svg
// module id = SsAK
// module chunks = 0